import React, { useEffect, useState, Fragment } from 'react';
import { ArrowLeftIcon, FileTextIcon, LockIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const SIDEBAR_SECTIONS = [{
  id: 'executive-summary',
  title: 'Executive Summary',
  status: 'active'
}, {
  id: 'the-problem',
  title: 'The Problem',
  status: 'active'
}, {
  id: 'the-solution',
  title: 'The Solution',
  status: 'active'
}, {
  id: 'market-opportunity',
  title: 'Market Opportunity',
  status: 'active'
}, {
  id: 'who-we-serve',
  title: 'Who We Serve',
  status: 'active'
}, {
  id: 'competitive-landscape',
  title: 'Competitive Landscape',
  status: 'active'
}, {
  id: 'founder-story',
  title: 'Founder Story',
  status: 'active'
}, {
  id: 'product-roadmap',
  title: 'Product Roadmap',
  status: 'active'
}, {
  id: 'business-model',
  title: 'Business Model',
  status: 'active'
}, {
  id: 'go-to-market',
  title: 'Go-to-Market',
  status: 'active'
}, {
  id: 'fundraising',
  title: 'Fundraising',
  status: 'active'
}, {
  id: 'curriculum',
  title: 'Curriculum',
  status: 'active'
}, {
  id: 'glossary',
  title: 'Glossary',
  status: 'active'
}];
export function InvestorBusinessPlanPage() {
  const [activeSection, setActiveSection] = useState('executive-summary');
  // Simple intersection observer to highlight active sidebar item
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    }, {
      rootMargin: '-20% 0px -80% 0px'
    });
    const sections = document.querySelectorAll('section[id]');
    sections.forEach(section => observer.observe(section));
    return () => {
      sections.forEach(section => observer.unobserve(section));
    };
  }, []);
  return <div className="min-h-screen bg-gray-50 font-sans text-[#111111] scroll-smooth" data-id="element-1742">
      {/* Private Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-1743">
        <div className="max-w-7xl mx-auto px-4 md:px-6 h-14 md:h-16 flex items-center justify-between" data-id="element-1744">
          <div className="flex items-center space-x-2 md:space-x-4 min-w-0" data-id="element-1745">
            <Link to="/investor-portal" className="text-gray-500 hover:text-[#631bb7] transition-colors shrink-0" data-id="element-1746">
              <ArrowLeftIcon size={18} data-id="element-1747" />
            </Link>
            <div className="h-5 w-px bg-gray-200 shrink-0" data-id="element-1748"></div>
            <img src="https://cdn.magicpatterns.com/uploads/u2RsmpFkExbV8oAVAJrtqh/Caveo-Lockup-FC.png" alt="Caveo" className="h-5 md:h-6 shrink-0" data-id="element-1749" />
            <span className="bg-gray-100 text-gray-600 text-[10px] md:text-xs font-semibold px-1.5 md:px-2 py-0.5 md:py-1 rounded-full uppercase tracking-wide shrink-0 hidden sm:inline-block" data-id="element-1750">
              Investor Portal
            </span>
          </div>
          <div className="text-xs md:text-sm text-gray-500 shrink-0 flex items-center gap-1.5" data-id="element-1751">
            <LockIcon size={14} data-id="element-1752" />
            Confidential
          </div>
        </div>
      </header>

      {/* Mobile Nav (Horizontal Scroll) */}
      <div className="md:hidden bg-white border-b border-gray-200 sticky top-14 z-40 overflow-x-auto whitespace-nowrap px-4 py-3 hide-scrollbar" data-id="element-1753">
        <div className="flex gap-2" data-id="element-1754">
          {SIDEBAR_SECTIONS.map(section => section.status === 'active' ? <button key={section.id} onClick={() => document.getElementById(section.id)?.scrollIntoView({
          behavior: 'smooth'
        })} className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors cursor-pointer border-0 ${activeSection === section.id ? 'bg-[#631bb7] text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} data-id="element-1755">
                {section.title}
              </button> : <span key={section.id} className="px-4 py-1.5 rounded-full text-sm font-medium bg-gray-50 text-gray-400 border border-gray-100 flex items-center gap-1.5" data-id="element-1756">
                {section.title}
                <span className="text-[10px] uppercase tracking-wider bg-gray-200 text-gray-500 px-1.5 py-0.5 rounded" data-id="element-1757">
                  Soon
                </span>
              </span>)}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 md:py-12 flex flex-col md:flex-row gap-8 lg:gap-12 items-start" data-id="element-1758">
        {/* Desktop Sidebar */}
        <aside className="hidden md:block w-64 shrink-0 sticky top-24" data-id="element-1759">
          <nav className="space-y-1" data-id="element-1760">
            <h3 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-4 px-3" data-id="element-1761">
              Contents
            </h3>
            {SIDEBAR_SECTIONS.map(section => section.status === 'active' ? <button key={section.id} onClick={() => document.getElementById(section.id)?.scrollIntoView({
            behavior: 'smooth'
          })} className={`block w-full text-left px-3 py-2 text-sm font-medium rounded-lg transition-colors border-l-2 cursor-pointer bg-transparent ${activeSection === section.id ? 'border-[#631bb7] text-[#631bb7] bg-[#f0ebf8]' : 'border-transparent text-gray-600 hover:bg-gray-100 hover:text-gray-900'}`} data-id="element-1762">
                  {section.title}
                </button> : <div key={section.id} className="px-3 py-2 text-sm font-medium text-gray-400 border-l-2 border-transparent flex items-center justify-between opacity-60 cursor-not-allowed" data-id="element-1763">
                  {section.title}
                  <span className="text-[9px] uppercase tracking-wider bg-gray-100 text-gray-500 px-1.5 py-0.5 rounded" data-id="element-1764">
                    Soon
                  </span>
                </div>)}
          </nav>
        </aside>

        {/* Main Content */}
        <main className="flex-1 max-w-4xl w-full space-y-16" data-id="element-1765">
          {/* Hero Section */}
          <div className="bg-[#1a0647] text-white rounded-2xl p-8 md:p-12 shadow-lg relative overflow-hidden" data-id="element-1766">
            <div className="relative z-10" data-id="element-1767">
              <h1 className="md:text-5xl font-bold mb-6 text-[40px] text-[#F8F8F8]" data-id="element-1768">
                The World's First Family IT Platform
              </h1>
              <p className="md:text-xl text-gray-200 max-w-3xl text-[18px]" data-id="element-1769">
                Caveo is the world’s first Family IT platform purpose-built to
                simplify digital security for the modern family. By replacing
                fragmented, technical tools with a unified, education-first
                experience, we transforms tech-exhausted households into
                confident digital citizens.
              </p>
            </div>
            {/* Abstract background decoration */}
            <div className="absolute top-0 right-0 -mt-10 -mr-10 w-64 h-64 bg-[#631bb7] rounded-full opacity-30 blur-3xl" data-id="element-1770"></div>
          </div>

          {/* Disclosure Banner */}
          <div className="bg-amber-50 border border-amber-200 rounded-xl px-5 py-4 flex items-start gap-3" data-id="element-1771">
            <span className="text-amber-500 text-lg leading-none mt-0.5 shrink-0" data-id="element-1772">
              ⚠️
            </span>
            <div className="text-sm text-amber-900 leading-relaxed" data-id="element-1773">
              <p className="font-semibold mb-1" data-id="element-1774">
                Version 11.0 · Last Updated: March 6, 2026
              </p>
              <p className="text-amber-800" data-id="element-1775">
                CONFIDENTIAL. This document contains proprietary information and
                strategic plans. Do not share externally without explicit
                authorization from Jason Phillips, Founder &amp; CEO. Comments,
                questions and feedback are welcome.
              </p>
            </div>
          </div>

          {/* Executive Summary */}
          <section id="executive-summary" className="scroll-mt-24 space-y-8" data-id="element-1776">
            <div data-id="element-1777">
              <p className="text-xs font-bold text-[#631bb7] uppercase tracking-wider mb-2" data-id="element-1778">
                Executive Summary
              </p>
              <h2 className="text-3xl md:text-4xl font-bold text-[#111111]" data-id="element-1779">
                The Opportunity in One Page
              </h2>
            </div>

            <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 shadow-sm space-y-10" data-id="element-1780">
              <div className="space-y-4" data-id="element-1781">
                <h3 className="text-xl font-bold text-[#631bb7]" data-id="element-1782">
                  The Mission: Bridging the Digital Literacy Gap ⚡
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-1783">
                  Caveo is the world’s first Family IT platform purpose-built to
                  simplify digital security for the modern family. By replacing
                  fragmented, technical tools with a unified, education-first
                  experience, Caveo transforms tech-exhausted households into
                  confident digital citizens. We address a $69.1B consumer
                  security market whose biggest players haven't actually made
                  consumers any safer from cybercrime.
                </p>
              </div>

              <div className="space-y-4" data-id="element-1784">
                <h3 className="text-xl font-bold text-[#631bb7]" data-id="element-1785">
                  The Problem: A Crisis of Complexity & A Failed Market 🚨
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-1786">
                  The consumer security market is broken. Families face a
                  landscape of inadequate choices: doing nothing and remaining
                  vulnerable, assembling a complex and costly stack of 4–7 point
                  solutions, or relying on reactive "black box" monitoring
                  suites from legacy players like Norton and Aura. These options
                  create an "expert burden," costing families over $1,000
                  annually while failing to prevent the human-error-driven
                  threats that cause the most harm. The result is a staggering,
                  underreported economic crisis, with true cybercrime losses
                  likely exceeding $100 billion annually in the U.S. alone. This
                  is not a user failure; it is a systemic design failure. The
                  industry has profited from complexity, leaving families
                  overpaying for a false sense of security.
                </p>
              </div>

              <div className="space-y-4" data-id="element-1787">
                <h3 className="text-xl font-bold text-[#631bb7]" data-id="element-1788">
                  The Caveo Solution: The IT Department for Your Family ✅
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-1789">
                  Just as every successful enterprise relies on an IT
                  department, Caveo provides the critical functions of
                  infrastructure, security, productivity, and governance for the
                  modern household. We are not another tool; we are the trusted
                  stewardship layer that standardizes a family's technology
                  stack, builds genuine digital capability through a proven
                  educational framework, and provides hands-on support when
                  needed. Our platform is built on a core philosophy of
                  enablement over surveillance, using an enterprise-grade change
                  management model (ADKAR) adapted for families. We succeed when
                  our users become self-sufficient, a business model directly
                  aligned with their best interests.
                </p>
                <p className="text-gray-600 leading-relaxed" data-id="element-1790">
                  In our current phase, the platform is education-first: guiding
                  families through a structured, personalized curriculum that
                  builds genuine digital capability. But Caveo is designed to
                  grow with its users. Over time, the platform layers in actual
                  software offerings — delivered through white-label
                  partnerships, curated third-party recommendations at the point
                  of need, or products built in-house — becoming not just the
                  guide, but the trusted technology stack that families rely on
                  for their entire digital lives.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-4" data-id="element-1791">
                <div className="bg-gray-50 p-5 rounded-xl border border-gray-100" data-id="element-1792">
                  <h4 className="font-bold text-[#111111] mb-2" data-id="element-1793">
                    Assess & Understand
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-1794">
                    Every journey begins with a short 3–4 minute initial
                    assessment — just enough to deliver your first quick win and
                    a personalized starting point before you've committed to
                    anything. Once you're onboard, Caveo continues building your
                    profile through the onboarding process, gathering the deeper
                    context needed to tailor your curriculum, identify your
                    highest-risk gaps, and generate a complete personalized
                    action plan. We earn your investment before we ask for your
                    information.
                  </p>
                </div>
                <div className="bg-gray-50 p-5 rounded-xl border border-gray-100" data-id="element-1795">
                  <h4 className="font-bold text-[#111111] mb-2" data-id="element-1796">
                    Educate & Enable
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-1797">
                    Our AI guide delivers 37 bite-sized, gamified learning
                    experiences (1 foundational intro + 28 core modules + 8
                    specialized guides) in plain English with no jargon. This is
                    not generic awareness training. It is structured capability
                    building through proven adult learning methodologies,
                    progressing from essential protections (Level 1) to
                    comprehensive security (Level 2) to advanced optimization
                    (Level 3).
                  </p>
                </div>
                <div className="bg-gray-50 p-5 rounded-xl border border-gray-100" data-id="element-1798">
                  <h4 className="font-bold text-[#111111] mb-2" data-id="element-1799">
                    Curated Recommendations
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-1800">
                    Throughout the curriculum, we surface vetted recommendations
                    at the point of need — never a generic list, always tailored
                    to each family's current setup and ideal future state. When
                    families complete password manager training, they see our
                    top 1–3 recommended providers that fit their specific device
                    ecosystem, budget, and comfort level. When built-in
                    protections are sufficient, we say so explicitly and
                    recommend against spending anything at all. We act as a
                    trusted advisor, not a product directory.
                  </p>
                </div>
                <div className="bg-gray-50 p-5 rounded-xl border border-gray-100" data-id="element-1801">
                  <h4 className="font-bold text-[#111111] mb-2" data-id="element-1802">
                    Implement & Support
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-1803">
                    We do not stop at telling families what to do. Through our
                    Remote Assist service, we provide hands-on implementation
                    support: live screen sharing, real-time troubleshooting, and
                    follow-up verification.
                  </p>
                </div>
                <div className="bg-gray-50 p-5 rounded-xl border border-gray-100" data-id="element-1804">
                  <h4 className="font-bold text-[#111111] mb-2" data-id="element-1805">
                    Activate Invisible Security
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-1806">
                    We do not sell redundant tools. We activate the
                    professional-grade protections already dormant in families'
                    existing devices, including built-in encryption, native
                    password managers, and device-level security features that
                    cost nothing but require expertise to configure properly.
                  </p>
                </div>
                <div className="bg-gray-50 p-5 rounded-xl border border-gray-100" data-id="element-1807">
                  <h4 className="font-bold text-[#111111] mb-2" data-id="element-1808">
                    Coordinate & Maintain
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-1809">
                    For multi-generational families, our role-based dashboards
                    give adult children visibility into their parents' progress
                    without being intrusive, reducing the 3–5 hours monthly
                    spent on "Family IT support." Proactive nudges, lifecycle
                    alerts, and ongoing maintenance support sustain new
                    practices and prevent backsliding.
                  </p>
                </div>
                <div className="bg-gray-50 p-5 rounded-xl border border-gray-100 md:col-span-2" data-id="element-1810">
                  <h4 className="font-bold text-[#111111] mb-2" data-id="element-1811">
                    Economic Clarity
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-1812">
                    By auditing digital bloat, eliminating redundant
                    subscriptions, and right-sizing technology spending, Caveo
                    typically saves families $500–1,000 annually.
                  </p>
                </div>
              </div>

              <div className="bg-[#f0ebf8] p-6 rounded-xl border border-[#e0d8f0]" data-id="element-1813">
                <p className="text-[#111111] font-medium leading-relaxed" data-id="element-1814">
                  <span className="font-bold text-[#631bb7]" data-id="element-1815">The Result:</span>{' '}
                  Families move from fragmented chaos to unified capability.
                  Individual stewards reclaim time and mental energy. Everyone
                  builds genuine digital literacy rather than dependency on
                  monitoring tools. This is enterprise IT change management,
                  adapted for the most important organization people belong to:
                  their family.
                </p>
              </div>

              <div className="space-y-6 pt-6 border-t border-gray-100" data-id="element-1816">
                <h3 className="text-xl font-bold text-[#631bb7]" data-id="element-1817">
                  Who We Serve & Competitive Edge 🍎
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-1818">
                  This transformation is possible because we have designed Caveo
                  from the ground up for the people who actually need it most.
                  Caveo is purpose-built for people who carry the responsibility
                  of keeping technology safe, functional, and low-stress for
                  their families, but our platform serves any individual seeking
                  the same systematic, capable approach to their digital
                  security.
                </p>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1819">
                  <div className="border border-gray-200 p-5 rounded-xl" data-id="element-1820">
                    <h4 className="font-bold text-[#111111] mb-2 text-sm" data-id="element-1821">
                      The Family Technology Steward (Primary ICP)
                    </h4>
                    <p className="text-xs text-gray-600" data-id="element-1822">
                      The adult child (typically a Millennial or Gen X
                      professional) who has become the default "family tech
                      support" for aging parents. They spend 3–5 hours monthly
                      troubleshooting across generations, sacrificing quality
                      time with family to fix Wi-Fi, update devices, and prevent
                      digital disasters. Caveo reduces their support burden,
                      restores their time, and preserves independence on both
                      sides of the family relationship. They are not just buying
                      security; they are buying back their weekends.
                    </p>
                  </div>
                  <div className="border border-gray-200 p-5 rounded-xl" data-id="element-1823">
                    <h4 className="font-bold text-[#111111] mb-2 text-sm" data-id="element-1824">
                      Gen X Executives & Professionals (Secondary ICP)
                    </h4>
                    <p className="text-xs text-gray-600" data-id="element-1825">
                      High-earning professionals who recently lost corporate IT
                      support through retirement or career transitions. They
                      want enterprise-grade security at home without
                      enterprise-level complexity. They have the income but not
                      the time or interest to become cybersecurity experts. They
                      want a trusted advisor who just makes it work.
                    </p>
                  </div>
                  <div className="border border-gray-200 p-5 rounded-xl" data-id="element-1826">
                    <h4 className="font-bold text-[#111111] mb-2 text-sm" data-id="element-1827">
                      Digitally Independent Older Adults
                    </h4>
                    <p className="text-xs text-gray-600" data-id="element-1828">
                      Tech-literate seniors (ages 61–75) who want to maintain
                      their digital independence without becoming a burden to
                      their children. They are capable but cautious, aware of
                      the risks but overwhelmed by the complexity. Caveo gives
                      them the tools to stay independent while their adult
                      children gain peace of mind.
                    </p>
                  </div>
                </div>

                <div className="space-y-4 pt-4" data-id="element-1829">
                  <h4 className="font-bold text-[#111111]" data-id="element-1830">Why We Win:</h4>
                  <ul className="space-y-3 text-sm text-gray-600" data-id="element-1831">
                    <li data-id="element-1832">
                      <strong className="text-[#111111]" data-id="element-1833">vs. Aura:</strong>{' '}
                      Modernized packaging, same reactive monitoring model.
                      Families do not need more alerts about breaches that
                      already happened. They need enablement to stop breaches
                      before they occur.
                    </li>
                    <li data-id="element-1834">
                      <strong className="text-[#111111]" data-id="element-1835">
                        vs. Legacy Monitoring (Norton, McAfee):
                      </strong>{' '}
                      They sell reactive insurance and fear. We sell proactive
                      capability through proven change management frameworks.
                      They alert you after the damage is done. We prevent it
                      from happening in the first place.
                    </li>
                    <li data-id="element-1836">
                      <strong className="text-[#111111]" data-id="element-1837">
                        vs. Point Solutions (1Password, NordVPN, Bitdefender):
                      </strong>{' '}
                      They assume you already know what you are doing. We enable
                      you to actually understand, implement, and maintain these
                      tools effectively. We are the missing instruction manual.
                    </li>
                    <li data-id="element-1838">
                      <strong className="text-[#111111]" data-id="element-1839">
                        vs. Break-Fix Services (Geek Squad, HelloTech):
                      </strong>{' '}
                      They profit from your ongoing tech failures and
                      dependency. We win when you become self-sufficient. Our
                      business model aligns with your success, not your
                      frustration.
                    </li>
                  </ul>
                  <p className="text-sm text-gray-600 mt-4 bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-1840">
                    <strong className="text-[#111111]" data-id="element-1841">The White Space:</strong>{' '}
                    No competitor recognizes that personal digital security is
                    about stewardship, not individual users. We serve the
                    steward, whether managing technology for a
                    multi-generational household or protecting their own digital
                    life with enterprise-grade rigor.
                  </p>
                </div>
              </div>

              <div className="space-y-4 pt-6 border-t border-gray-100" data-id="element-1842">
                <h3 className="text-xl font-bold text-[#631bb7]" data-id="element-1843">
                  Market Opportunity & Go-to-Market 🌍
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-1844">
                  We are targeting a $9.74 billion bottom-up TAM within the $30
                  billion North American consumer security market. Our beachhead
                  is the $3.02 billion SAM of adult children supporting aging
                  parents. We project achieving $480 million in ARR within five
                  years by capturing 1.6–2 million families. Our go-to-market
                  strategy begins with a direct-to-consumer, content-led
                  approach, expanding through institutional B2B2C partnerships
                  with school districts, enterprises, and financial
                  institutions.
                </p>
              </div>

              <div className="space-y-4 pt-6 border-t border-gray-100" data-id="element-1845">
                <h3 className="text-xl font-bold text-[#631bb7]" data-id="element-1846">
                  The Ask & The Vision 🔲
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-1847">
                  We have reached an inflection point and are currently raising
                  a $275K SAFE with an $8M post-money valuation cap. Caveo has
                  never been better positioned, and waiting means leaving a real
                  competitive advantage on the table.
                </p>
                <p className="text-gray-600 leading-relaxed" data-id="element-1848">
                  Four forces are converging at once. Boomers are aging into the
                  highest-risk demographic for digital fraud while still living
                  independently online. Millennials are caught in the middle,
                  managing screen time for their kids and tech support calls
                  from their parents. Remote work, online schooling, and
                  telemedicine have permanently expanded the digital footprint
                  of the average household. Families have more exposure than
                  ever, and that's a new baseline, not a trend.
                </p>
                <p className="text-gray-600 leading-relaxed" data-id="element-1849">
                  At the same time, AI and machine learning capabilities that
                  once required enterprise infrastructure can now be deployed at
                  consumer price points. Adaptive experiences and predictive
                  threat detection are achievable today in ways they weren't
                  even two years ago. Lean teams can ship what took 18 months in
                  a fraction of the time.
                </p>
                <p className="text-gray-600 leading-relaxed" data-id="element-1850">
                  The competitive gap is structural. The incumbents are locked
                  into legacy models built around software installations and
                  monitoring subscriptions. None of them are addressing the full
                  multi-generational family use case with an education-first
                  approach, and they can't without cannibalizing what they
                  already sell.
                </p>
                <p className="text-gray-600 leading-relaxed" data-id="element-1851">
                  77% of people now believe security practices are worth the
                  effort, up 17% from the prior year. The market is motivated.
                  The problem is that awareness and execution are two very
                  different things. People know what they should do; they just
                  don't know how to actually do it. That gap between knowing and
                  doing is exactly where Caveo lives. The $275,000 SAFE round is
                  about acceleration. The technology is ready, the demand is
                  proven, the competitive vacuum exists right now, and the
                  audience is primed to act. This round is how we step into it.
                </p>
              </div>
            </div>
          </section>

          {/* The Problem */}
          <section id="the-problem" className="scroll-mt-24 space-y-8" data-id="element-1852">
            <div data-id="element-1853">
              <p className="text-xs font-bold text-[#631bb7] uppercase tracking-wider mb-2" data-id="element-1854">
                Section 1
              </p>
              <h2 className="text-3xl md:text-4xl font-bold text-[#111111]" data-id="element-1855">
                Three Simultaneous Failures
              </h2>
            </div>

            <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 shadow-sm space-y-10" data-id="element-1856">
              <p className="text-gray-600 leading-relaxed text-lg" data-id="element-1857">
                The average American household now manages 22 connected devices,
                yet 64% of Americans have never used a password manager, 73%
                reuse passwords across multiple accounts, and 81% have no formal
                backup strategy. This is not a technology shortage. It is a
                guidance shortage.
              </p>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1858">
                <div className="bg-gray-50 border border-gray-100 rounded-xl p-6 text-center flex flex-col items-center justify-center" data-id="element-1859">
                  <span className="text-4xl font-bold text-[#631bb7] mb-2" data-id="element-1860">
                    22
                  </span>
                  <span className="font-bold text-[#111111] text-sm mb-1" data-id="element-1861">
                    Connected devices per household
                  </span>
                  <span className="text-xs text-gray-500" data-id="element-1862">
                    Average U.S. home, 2024
                  </span>
                </div>
                <div className="bg-gray-50 border border-gray-100 rounded-xl p-6 text-center flex flex-col items-center justify-center" data-id="element-1863">
                  <span className="text-4xl font-bold text-[#631bb7] mb-2" data-id="element-1864">
                    64%
                  </span>
                  <span className="font-bold text-[#111111] text-sm mb-1" data-id="element-1865">
                    Never used a password manager
                  </span>
                  <span className="text-xs text-gray-500" data-id="element-1866">
                    Despite widespread availability
                  </span>
                </div>
                <div className="bg-gray-50 border border-gray-100 rounded-xl p-6 text-center flex flex-col items-center justify-center" data-id="element-1867">
                  <span className="text-4xl font-bold text-[#631bb7] mb-2" data-id="element-1868">
                    $16.6B
                  </span>
                  <span className="font-bold text-[#111111] text-sm mb-1" data-id="element-1869">
                    Cybercrime losses in 2024
                  </span>
                  <span className="text-xs text-gray-500" data-id="element-1870">
                    FBI IC3 Report, 2024
                  </span>
                </div>
              </div>

              <div className="space-y-8" data-id="element-1871">
                <div data-id="element-1872">
                  <h3 className="text-xl font-bold text-[#631bb7] mb-3" data-id="element-1873">
                    Failure 1: The Tools Are Too Complex
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-1874">
                    The cybersecurity industry was built by engineers for
                    engineers. Password managers, VPNs, and backup solutions are
                    powerful but assume a level of technical literacy that most
                    families simply don't have. The result is a $416-$1,030 per
                    year fragmented stack of point solutions with different
                    logins, renewal dates, and no unified family view.
                  </p>
                </div>

                <div data-id="element-1875">
                  <h3 className="text-xl font-bold text-[#631bb7] mb-3" data-id="element-1876">
                    Failure 2: The Industry Profits from Fear and Confusion
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-1877">
                    Legacy players like Norton, McAfee, and Aura have built
                    businesses on reactive monitoring. They alert you after a
                    breach has already happened. They don't teach prevention.
                    They don't build competence. And critically, they earn
                    affiliate revenue from the products they recommend, creating
                    a fundamental conflict of interest that Caveo eliminates
                    entirely.
                  </p>
                </div>

                <div data-id="element-1878">
                  <h3 className="text-xl font-bold text-[#631bb7] mb-3" data-id="element-1879">
                    Failure 3: The Multi-Generational Gap Is Ignored
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-1880">
                    No existing solution addresses the reality of how families
                    actually work. A Millennial adult child manages technology
                    for aging Boomer parents who are the most targeted
                    demographic for cybercrime. Seniors lost $3.4 billion to
                    fraud in 2023 alone. The tools that exist are either
                    designed for individuals or for corporate IT departments.
                    Nothing exists for the family unit.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* The Solution */}
          <section id="the-solution" className="scroll-mt-24 space-y-8" data-id="element-1881">
            <div data-id="element-1882">
              <p className="text-xs font-bold text-[#631bb7] uppercase tracking-wider mb-2" data-id="element-1883">
                Section 2
              </p>
              <h2 className="text-3xl md:text-4xl font-bold text-[#111111]" data-id="element-1884">
                The Home IT Department
              </h2>
            </div>

            <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 shadow-sm space-y-10" data-id="element-1885">
              <p className="text-gray-600 leading-relaxed text-lg" data-id="element-1886">
                Caveo is the governance layer for the modern family's digital
                life. We operate across four domains that enterprise IT
                departments have managed for decades, now adapted for
                households: Infrastructure, Security, Productivity, and
                Governance.
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1887">
                <div className="bg-gray-50 border border-gray-100 rounded-xl p-6" data-id="element-1888">
                  <div className="text-3xl mb-3" data-id="element-1889">🏗️</div>
                  <h4 className="font-bold text-[#111111] text-lg mb-2" data-id="element-1890">
                    Infrastructure
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-1891">
                    Device inventory, network security, and standardized tool
                    selection. We know what you have and ensure it works
                    correctly.
                  </p>
                </div>
                <div className="bg-gray-50 border border-gray-100 rounded-xl p-6" data-id="element-1892">
                  <div className="text-3xl mb-3" data-id="element-1893">🔒</div>
                  <h4 className="font-bold text-[#111111] text-lg mb-2" data-id="element-1894">
                    Security
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-1895">
                    MFA setup, password hygiene, scam recognition, and device
                    hardening. Most threats are stopped quietly before a family
                    member encounters them.
                  </p>
                </div>
                <div className="bg-gray-50 border border-gray-100 rounded-xl p-6" data-id="element-1896">
                  <div className="text-3xl mb-3" data-id="element-1897">⚡</div>
                  <h4 className="font-bold text-[#111111] text-lg mb-2" data-id="element-1898">
                    Productivity
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-1899">
                    Standardized tools, automated maintenance, and
                    role-appropriate training. The same questions stop coming
                    back.
                  </p>
                </div>
                <div className="bg-gray-50 border border-gray-100 rounded-xl p-6" data-id="element-1900">
                  <div className="text-3xl mb-3" data-id="element-1901">📋</div>
                  <h4 className="font-bold text-[#111111] text-lg mb-2" data-id="element-1902">
                    Governance
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-1903">
                    Subscription audits, access management, and digital estate
                    planning. The system of record for the family's entire
                    digital life.
                  </p>
                </div>
              </div>

              <div className="space-y-8 pt-4" data-id="element-1904">
                <div data-id="element-1905">
                  <h3 className="text-xl font-bold text-[#631bb7] mb-4" data-id="element-1906">
                    The ADKAR Framework, Applied to Families
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-4" data-id="element-1907">
                    Our methodology mirrors the ADKAR change management model
                    used by Fortune 500 companies (Awareness, Desire, Knowledge,
                    Ability, Reinforcement), adapted specifically for household
                    digital transformation. We don't just hand families a
                    checklist. We walk them through a structured journey.
                  </p>
                  <ul className="space-y-4" data-id="element-1908">
                    <li className="flex gap-4 items-start" data-id="element-1909">
                      <div className="w-8 h-8 rounded-full bg-[#f0ebf8] text-[#631bb7] font-bold flex items-center justify-center shrink-0 mt-0.5" data-id="element-1910">
                        1
                      </div>
                      <p className="text-gray-600" data-id="element-1911">
                        <strong className="text-[#111111]" data-id="element-1912">Assess:</strong> A
                        3-4 minute initial assessment delivers the first quick
                        win and a personalized starting point before any
                        commitment is required.
                      </p>
                    </li>
                    <li className="flex gap-4 items-start" data-id="element-1913">
                      <div className="w-8 h-8 rounded-full bg-[#f0ebf8] text-[#631bb7] font-bold flex items-center justify-center shrink-0 mt-0.5" data-id="element-1914">
                        2
                      </div>
                      <p className="text-gray-600" data-id="element-1915">
                        <strong className="text-[#111111]" data-id="element-1916">Educate:</strong> 37
                        bite-sized, gamified learning experiences in plain
                        English. No jargon. Structured through proven adult
                        learning methodologies.
                      </p>
                    </li>
                    <li className="flex gap-4 items-start" data-id="element-1917">
                      <div className="w-8 h-8 rounded-full bg-[#f0ebf8] text-[#631bb7] font-bold flex items-center justify-center shrink-0 mt-0.5" data-id="element-1918">
                        3
                      </div>
                      <p className="text-gray-600" data-id="element-1919">
                        <strong className="text-[#111111]" data-id="element-1920">Curate:</strong>{' '}
                        Vetted recommendations at the point of need, never a
                        generic list. When built-in protections are sufficient,
                        we say so explicitly.
                      </p>
                    </li>
                    <li className="flex gap-4 items-start" data-id="element-1921">
                      <div className="w-8 h-8 rounded-full bg-[#f0ebf8] text-[#631bb7] font-bold flex items-center justify-center shrink-0 mt-0.5" data-id="element-1922">
                        4
                      </div>
                      <p className="text-gray-600" data-id="element-1923">
                        <strong className="text-[#111111]" data-id="element-1924">Coordinate:</strong>{' '}
                        Role-based dashboards give adult children visibility
                        into parents' progress without being intrusive.
                      </p>
                    </li>
                    <li className="flex gap-4 items-start" data-id="element-1925">
                      <div className="w-8 h-8 rounded-full bg-[#f0ebf8] text-[#631bb7] font-bold flex items-center justify-center shrink-0 mt-0.5" data-id="element-1926">
                        5
                      </div>
                      <p className="text-gray-600" data-id="element-1927">
                        <strong className="text-[#111111]" data-id="element-1928">Sustain:</strong>{' '}
                        Proactive nudges, lifecycle alerts, and ongoing
                        maintenance prevent backsliding.
                      </p>
                    </li>
                  </ul>
                </div>

                <div data-id="element-1929">
                  <h3 className="text-xl font-bold text-[#631bb7] mb-3" data-id="element-1930">
                    AI as the Simplicity Engine
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-1931">
                    Our AI guide is the interface between complexity and
                    confidence. It translates technical concepts into plain
                    English, delivers personalized recommendations based on each
                    family's actual setup, and provides contextual guidance at
                    the exact moment a family member needs it. The AI doesn't
                    replace human judgment. It makes human judgment possible for
                    people who previously felt locked out of the conversation.
                  </p>
                </div>

                <div data-id="element-1932">
                  <h3 className="text-xl font-bold text-[#631bb7] mb-3" data-id="element-1933">
                    The 1,000-Point Scoring System
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-1934">
                    Every family receives a security score out of 1,000 points.
                    This score is not a marketing gimmick. It is a genuine
                    capability map: 450 points for Level 1 (Essential Safety),
                    550 points for Level 2 (Intermediate Protection), and
                    additional points for Level 3 (Advanced Optimization). A
                    score of 1,000 represents legitimate, comprehensive security
                    for a modern household.
                  </p>
                </div>

                <div data-id="element-1935">
                  <h3 className="text-xl font-bold text-[#631bb7] mb-3" data-id="element-1936">
                    Role-Based Architecture
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-1937">
                    Caveo supports five distinct family member roles, each with
                    a tailored experience: the Family Tech Steward (the adult
                    child managing everything), the Independent Senior
                    (self-directed, privacy-conscious), the Supported Senior
                    (needs guided assistance), the Digital Native (teenager or
                    young adult), and the Casual User (the family member who
                    just wants things to work). Each role receives a different
                    onboarding flow, dashboard view, and curriculum path.
                  </p>
                </div>

                <div data-id="element-1938">
                  <h3 className="text-xl font-bold text-[#631bb7] mb-3" data-id="element-1939">
                    The Governance Charter
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-1940">
                    Every family that joins Caveo establishes a Governance
                    Charter: a shared agreement about roles, permissions, and
                    expectations. Who has access to what? Who gets notified when
                    something changes? What happens to digital accounts when a
                    family member passes? These are the questions that corporate
                    IT departments answer with formal policy. Caveo answers them
                    for families with consent-based, plain-English agreements.
                  </p>
                </div>

                <div data-id="element-1941">
                  <h3 className="text-xl font-bold text-[#631bb7] mb-3" data-id="element-1942">
                    When Caveo Acts as Guardian
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-1943">
                    For families with aging parents or members who need
                    additional protection, Caveo provides a guardian mode. The
                    Family Tech Steward can receive alerts about unusual
                    activity, help with device setup, and monitor security
                    progress without being intrusive. This is not surveillance.
                    It is stewardship, with full transparency and consent from
                    every family member involved.
                  </p>
                </div>

                <div data-id="element-1944">
                  <h3 className="text-xl font-bold text-[#631bb7] mb-4" data-id="element-1945">
                    The Business Case, Translated
                  </h3>
                  <ul className="space-y-3 text-gray-600" data-id="element-1946">
                    <li data-id="element-1947">
                      <strong className="text-[#111111]" data-id="element-1948">Cost Control:</strong>{' '}
                      The average U.S. household wastes over $300/year on
                      redundant subscriptions. Caveo audits and consolidates
                      that spend.
                    </li>
                    <li data-id="element-1949">
                      <strong className="text-[#111111]" data-id="element-1950">
                        Risk Reduction:
                      </strong>{' '}
                      Identity theft costs a family an average of $1,200 in
                      direct losses, plus the massive toll of credit recovery.
                    </li>
                    <li data-id="element-1951">
                      <strong className="text-[#111111]" data-id="element-1952">
                        Operational Continuity:
                      </strong>{' '}
                      When a device fails or an account is compromised, Caveo
                      ensures a backup plan is already in place.
                    </li>
                    <li data-id="element-1953">
                      <strong className="text-[#111111]" data-id="element-1954">
                        Family Experience:
                      </strong>{' '}
                      From onboarding an aging parent to a password manager to
                      setting up new devices, Caveo provides a guided,
                      role-appropriate experience.
                    </li>
                    <li data-id="element-1955">
                      <strong className="text-[#111111]" data-id="element-1956">Scalability:</strong> A
                      two-person household can manage informally. Add teenagers,
                      aging parents, and digital estate planning, and informal
                      stops working.
                    </li>
                    <li data-id="element-1957">
                      <strong className="text-[#111111]" data-id="element-1958">
                        Strategic Enablement:
                      </strong>{' '}
                      Caveo's AI guidance layer proactively identifies
                      vulnerabilities and builds household digital fluency over
                      time.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* Market Opportunity */}
          <section id="market-opportunity" className="scroll-mt-24 space-y-8" data-id="element-1959">
            <div data-id="element-1960">
              <p className="text-xs font-bold text-[#631bb7] uppercase tracking-wider mb-2" data-id="element-1961">
                Section 3
              </p>
              <h2 className="text-3xl md:text-4xl font-bold text-[#111111]" data-id="element-1962">
                A $9.74B Bottom-Up Opportunity
              </h2>
            </div>

            <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 shadow-sm space-y-10" data-id="element-1963">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1964">
                <div className="bg-gray-50 border border-gray-100 rounded-xl p-6 text-center flex flex-col items-center justify-center" data-id="element-1965">
                  <span className="text-4xl font-bold text-[#631bb7] mb-2" data-id="element-1966">
                    $69.1B
                  </span>
                  <span className="font-bold text-[#111111] text-sm mb-1" data-id="element-1967">
                    Total Addressable Market
                  </span>
                  <span className="text-xs text-gray-500" data-id="element-1968">
                    Global consumer digital safety, 2024
                  </span>
                </div>
                <div className="bg-gray-50 border border-gray-100 rounded-xl p-6 text-center flex flex-col items-center justify-center" data-id="element-1969">
                  <span className="text-4xl font-bold text-[#631bb7] mb-2" data-id="element-1970">
                    $9.74B
                  </span>
                  <span className="font-bold text-[#111111] text-sm mb-1" data-id="element-1971">
                    Bottom-Up TAM
                  </span>
                  <span className="text-xs text-gray-500" data-id="element-1972">
                    40.6M households × $240 ARPU
                  </span>
                </div>
                <div className="bg-gray-50 border border-gray-100 rounded-xl p-6 text-center flex flex-col items-center justify-center" data-id="element-1973">
                  <span className="text-4xl font-bold text-[#631bb7] mb-2" data-id="element-1974">
                    $480M
                  </span>
                  <span className="font-bold text-[#111111] text-sm mb-1" data-id="element-1975">
                    Year 5 ARR Target
                  </span>
                  <span className="text-xs text-gray-500" data-id="element-1976">
                    5% of SAM ($3.02B North America)
                  </span>
                </div>
              </div>

              <div className="space-y-4" data-id="element-1977">
                <h3 className="text-xl font-bold text-[#631bb7]" data-id="element-1978">
                  Bottom-Up TAM Calculation
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-1979">
                  Our bottom-up analysis starts with 40.6 million qualified U.S.
                  households: multi-generational families with at least one
                  member over 60 and one member aged 29-44 who manages family
                  technology. Applying a 3.5x household multiplier (reflecting
                  the average number of adults per qualifying household) yields
                  142 million total addressable users. At our $240 average
                  revenue per user (ARPU), this represents a $9.74 billion
                  annual revenue potential.
                </p>
              </div>

              <div className="space-y-4" data-id="element-1980">
                <h3 className="text-xl font-bold text-[#631bb7]" data-id="element-1981">
                  Market Sizing Funnel
                </h3>
                <div className="space-y-3" data-id="element-1982">
                  <div className="flex items-center gap-4 bg-[#1a0647] text-white p-5 rounded-xl" data-id="element-1983">
                    <div className="flex-1" data-id="element-1984">
                      <p className="font-bold text-lg" data-id="element-1985">Global TAM</p>
                      <p className="text-sm text-gray-300" data-id="element-1986">
                        Consumer digital safety market
                      </p>
                    </div>
                    <span className="text-2xl font-bold text-[#b063ff]" data-id="element-1987">
                      $69.1B
                    </span>
                  </div>
                  <div className="flex items-center gap-4 bg-[#2a1060] text-white p-5 rounded-xl" data-id="element-1988">
                    <div className="flex-1" data-id="element-1989">
                      <p className="font-bold text-lg" data-id="element-1990">North America SAM</p>
                      <p className="text-sm text-gray-300" data-id="element-1991">
                        English-speaking, family-focused households
                      </p>
                    </div>
                    <span className="text-2xl font-bold text-[#b063ff]" data-id="element-1992">
                      $30B
                    </span>
                  </div>
                  <div className="flex items-center gap-4 bg-[#3d1a80] text-white p-5 rounded-xl" data-id="element-1993">
                    <div className="flex-1" data-id="element-1994">
                      <p className="font-bold text-lg" data-id="element-1995">
                        Family Subscription SAM
                      </p>
                      <p className="text-sm text-gray-300" data-id="element-1996">
                        40.6M households × $240 ARPU
                      </p>
                    </div>
                    <span className="text-2xl font-bold text-[#b063ff]" data-id="element-1997">
                      $9.74B
                    </span>
                  </div>
                  <div className="flex items-center gap-4 bg-[#631bb7] text-white p-5 rounded-xl" data-id="element-1998">
                    <div className="flex-1" data-id="element-1999">
                      <p className="font-bold text-lg" data-id="element-2000">Year 5 SOM</p>
                      <p className="text-sm text-gray-200" data-id="element-2001">
                        5% market capture at scale
                      </p>
                    </div>
                    <span className="text-2xl font-bold text-white" data-id="element-2002">
                      $480M ARR
                    </span>
                  </div>
                </div>
              </div>

              <div className="space-y-4" data-id="element-2003">
                <h3 className="text-xl font-bold text-[#631bb7]" data-id="element-2004">
                  Why the Market Is Ready Now
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-2005">
                  Four forces are converging simultaneously. Cybercrime losses
                  hit $16.6 billion in 2024 (FBI IC3), making digital security a
                  mainstream household concern rather than a niche technical
                  interest. The 73 million Baby Boomers aging into their most
                  vulnerable digital years represent the fastest-growing and
                  most targeted demographic. AI has finally made personalized,
                  plain-English guidance economically viable at scale. And the
                  COVID-19 pandemic permanently accelerated digital adoption
                  across all age groups, creating demand that legacy tools are
                  structurally unable to serve.
                </p>
              </div>
            </div>
          </section>

          {/* Who We Serve */}
          <section id="who-we-serve" className="scroll-mt-24 space-y-8" data-id="element-2006">
            <div data-id="element-2007">
              <p className="text-xs font-bold text-[#631bb7] uppercase tracking-wider mb-2" data-id="element-2008">
                Section 4
              </p>
              <h2 className="text-3xl md:text-4xl font-bold text-[#111111]" data-id="element-2009">
                Three Primary Segments
              </h2>
            </div>

            <div className="space-y-6" data-id="element-2010">
              {/* Primary ICP */}
              <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 shadow-sm space-y-6" data-id="element-2011">
                <div className="flex items-center gap-3" data-id="element-2012">
                  <span className="text-3xl" data-id="element-2013">👨‍👩‍👧‍👦</span>
                  <div data-id="element-2014">
                    <p className="text-xs font-bold text-[#631bb7] uppercase tracking-wider" data-id="element-2015">
                      Primary Segment — ICP
                    </p>
                    <h3 className="text-2xl font-bold text-[#111111]" data-id="element-2016">
                      Family Tech Steward
                    </h3>
                  </div>
                </div>
                <p className="text-sm text-gray-500 font-medium" data-id="element-2017">
                  Ages 29-44 (Millennials) · Market Size: 22M U.S. households
                  (17% of all households)
                </p>
                <p className="text-gray-600 leading-relaxed" data-id="element-2018">
                  The tech-savvy adult child who manages digital security for
                  their entire family. They are the unofficial IT department for
                  their household, their parents, and sometimes their in-laws.
                  They are overwhelmed, time-constrained, and deeply motivated
                  by love and responsibility.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2019">
                  <div className="bg-gray-50 p-4 rounded-xl border border-gray-100" data-id="element-2020">
                    <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-1" data-id="element-2021">
                      What They Buy
                    </p>
                    <p className="text-sm text-[#111111] font-medium" data-id="element-2022">
                      Family plan ($19.99/mo) + Remote Assist ($9.99/mo)
                    </p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-xl border border-gray-100" data-id="element-2023">
                    <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-1" data-id="element-2024">
                      Buying Trigger
                    </p>
                    <p className="text-sm text-[#111111] font-medium" data-id="element-2025">
                      Parent falls for a scam or calls them for the fifth time
                      about the same tech issue
                    </p>
                  </div>
                </div>
              </div>

              {/* Secondary Segment */}
              <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 shadow-sm space-y-6" data-id="element-2026">
                <div className="flex items-center gap-3" data-id="element-2027">
                  <span className="text-3xl" data-id="element-2028">👴</span>
                  <div data-id="element-2029">
                    <p className="text-xs font-bold text-[#631bb7] uppercase tracking-wider" data-id="element-2030">
                      Secondary Segment
                    </p>
                    <h3 className="text-2xl font-bold text-[#111111]" data-id="element-2031">
                      Independent Senior
                    </h3>
                  </div>
                </div>
                <p className="text-sm text-gray-500 font-medium" data-id="element-2032">
                  Ages 61+ (Boomers) · Market Size: 18.5M U.S. households (14%
                  of all households)
                </p>
                <p className="text-gray-600 leading-relaxed" data-id="element-2033">
                  Tech-curious Boomers who want to manage their own digital
                  security without relying on their children. They are
                  self-directed, privacy-conscious, and deeply motivated by
                  maintaining their independence and dignity. They are the most
                  targeted demographic for cybercrime and they know it.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2034">
                  <div className="bg-gray-50 p-4 rounded-xl border border-gray-100" data-id="element-2035">
                    <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-1" data-id="element-2036">
                      What They Buy
                    </p>
                    <p className="text-sm text-[#111111] font-medium" data-id="element-2037">
                      Individual plan ($7.99/mo), often gifted by adult children
                    </p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-xl border border-gray-100" data-id="element-2038">
                    <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-1" data-id="element-2039">
                      Why They Matter
                    </p>
                    <p className="text-sm text-[#111111] font-medium" data-id="element-2040">
                      Low CAC via content marketing. High retention. Ideal for
                      AARP-style partnerships.
                    </p>
                  </div>
                </div>
              </div>

              {/* Tertiary Segment */}
              <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 shadow-sm space-y-6" data-id="element-2041">
                <div className="flex items-center gap-3" data-id="element-2042">
                  <span className="text-3xl" data-id="element-2043">💼</span>
                  <div data-id="element-2044">
                    <p className="text-xs font-bold text-[#631bb7] uppercase tracking-wider" data-id="element-2045">
                      Tertiary Segment — White Space
                    </p>
                    <h3 className="text-2xl font-bold text-[#111111]" data-id="element-2046">
                      Retiring Professional
                    </h3>
                  </div>
                </div>
                <p className="text-sm text-gray-500 font-medium" data-id="element-2047">
                  Ages 45-60 (Gen X) · Market Size: 40M U.S. households (30% of
                  all households)
                </p>
                <p className="text-gray-600 leading-relaxed" data-id="element-2048">
                  Non-technical Gen X professionals retiring after relying on
                  corporate IT for 20-30 years. They are used to having an IT
                  department handle everything at work. Now they need that same
                  reliability for their personal lives. They have the income but
                  not the time or interest to become cybersecurity experts.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2049">
                  <div className="bg-gray-50 p-4 rounded-xl border border-gray-100" data-id="element-2050">
                    <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-1" data-id="element-2051">
                      The Multiplier Effect
                    </p>
                    <p className="text-sm text-[#111111] font-medium" data-id="element-2052">
                      Buy for self + spouse → refer friends in retirement
                      communities → high-value referrals
                    </p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-xl border border-gray-100" data-id="element-2053">
                    <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-1" data-id="element-2054">
                      Buying Trigger
                    </p>
                    <p className="text-sm text-[#111111] font-medium" data-id="element-2055">
                      Retirement moment when they realize they have no helpdesk
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Competitive Landscape */}
          <section id="competitive-landscape" className="scroll-mt-24 space-y-8" data-id="element-2056">
            <div data-id="element-2057">
              <p className="text-xs font-bold text-[#631bb7] uppercase tracking-wider mb-2" data-id="element-2058">
                Section 5
              </p>
              <h2 className="text-3xl md:text-4xl font-bold text-[#111111]" data-id="element-2059">
                Why Every Existing Solution Falls Short
              </h2>
            </div>

            <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 shadow-sm space-y-10" data-id="element-2060">
              <p className="text-gray-600 leading-relaxed text-lg" data-id="element-2061">
                The competitive landscape is not a single category. It is a
                fragmented collection of point solutions, monitoring suites, and
                OS-native tools, each solving one piece of the problem while
                ignoring the rest. Caveo is the first platform to address all
                four failure modes simultaneously.
              </p>

              <div className="space-y-6" data-id="element-2062">
                <h3 className="text-xl font-bold text-[#631bb7]" data-id="element-2063">
                  The Point Solutions Problem: Forced Fragmentation
                </h3>

                <div className="space-y-4" data-id="element-2064">
                  <div className="border border-gray-200 rounded-xl p-5" data-id="element-2065">
                    <h4 className="font-bold text-[#111111] mb-2" data-id="element-2066">
                      Password Managers (1Password, Bitwarden)
                    </h4>
                    <p className="text-sm text-gray-600 mb-2" data-id="element-2067">
                      Solve password reuse elegantly for technical users but
                      fail the 64% of Americans who don't use them due to
                      complex setup and confusing family sharing.
                    </p>
                    <p className="text-sm text-[#631bb7] font-medium" data-id="element-2068">
                      Caveo: Bridges this adoption gap with guided,
                      plain-English education.
                    </p>
                  </div>
                  <div className="border border-gray-200 rounded-xl p-5" data-id="element-2069">
                    <h4 className="font-bold text-[#111111] mb-2" data-id="element-2070">
                      VPNs (ExpressVPN, NordVPN)
                    </h4>
                    <p className="text-sm text-gray-600 mb-2" data-id="element-2071">
                      Encrypt traffic on public networks, but most families
                      don't need them for everyday home use.
                    </p>
                    <p className="text-sm text-[#631bb7] font-medium" data-id="element-2072">
                      Caveo: Provides contextual guidance, eliminating
                      unnecessary spending.
                    </p>
                  </div>
                  <div className="border border-gray-200 rounded-xl p-5" data-id="element-2073">
                    <h4 className="font-bold text-[#111111] mb-2" data-id="element-2074">
                      Cloud Backup (Backblaze, Carbonite)
                    </h4>
                    <p className="text-sm text-gray-600 mb-2" data-id="element-2075">
                      Offer automated offsite backup, but users often don't
                      verify they work until disaster strikes.
                    </p>
                    <p className="text-sm text-[#631bb7] font-medium" data-id="element-2076">
                      Caveo: Teaches a proper backup strategy (the 3-2-1 rule)
                      and automates verification.
                    </p>
                  </div>
                  <div className="border border-gray-200 rounded-xl p-5" data-id="element-2077">
                    <h4 className="font-bold text-[#111111] mb-2" data-id="element-2078">
                      Data Broker Removal (DeleteMe, Incogni)
                    </h4>
                    <p className="text-sm text-gray-600 mb-2" data-id="element-2079">
                      Remove personal info from people-search sites, but most
                      families don't even know these services exist.
                    </p>
                    <p className="text-sm text-[#631bb7] font-medium" data-id="element-2080">
                      Caveo: Educates first, then recommends services where the
                      cost is justified.
                    </p>
                  </div>
                </div>
              </div>

              <div className="space-y-6" data-id="element-2081">
                <h3 className="text-xl font-bold text-[#631bb7]" data-id="element-2082">
                  The All-In-One Suites Problem: Monitoring Without Education
                </h3>

                <div className="space-y-4" data-id="element-2083">
                  <div className="border border-gray-200 rounded-xl p-5" data-id="element-2084">
                    <h4 className="font-bold text-[#111111] mb-2" data-id="element-2085">Aura</h4>
                    <p className="text-sm text-gray-600" data-id="element-2086">
                      Modernized the packaging but still operates on the same
                      reactive monitoring model. A better version of the old
                      approach, but still the wrong approach. Families don't
                      need more alerts about breaches that already happened.
                      They need enablement to stop breaches before they occur.
                    </p>
                  </div>
                  <div className="border border-gray-200 rounded-xl p-5" data-id="element-2087">
                    <h4 className="font-bold text-[#111111] mb-2" data-id="element-2088">
                      Norton 360, McAfee
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-2089">
                      Bundle antivirus, firewalls, and VPNs, but require expert
                      configuration and are bloated with overwhelming
                      interfaces. They assume users know what they need and
                      offer no educational component.
                    </p>
                  </div>
                  <div className="border border-gray-200 rounded-xl p-5" data-id="element-2090">
                    <h4 className="font-bold text-[#111111] mb-2" data-id="element-2091">
                      Geek Squad, HelloTech
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-2092">
                      Profit from ongoing tech failures and dependency. We win
                      when you become self-sufficient. Our business model aligns
                      with your success, not your frustration.
                    </p>
                  </div>
                </div>
              </div>

              <div className="space-y-4" data-id="element-2093">
                <h3 className="text-xl font-bold text-[#631bb7]" data-id="element-2094">
                  The Four Competitive Gaps Caveo Exploits
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2095">
                  <div className="bg-[#f0ebf8] p-5 rounded-xl border border-[#e0d8f0]" data-id="element-2096">
                    <h4 className="font-bold text-[#631bb7] mb-2" data-id="element-2097">
                      Fragmentation
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-2098">
                      We consolidate the fragmented stack of point solutions
                      down to what's strictly necessary based on the customer's
                      needs and risk profile.
                    </p>
                  </div>
                  <div className="bg-[#f0ebf8] p-5 rounded-xl border border-[#e0d8f0]" data-id="element-2099">
                    <h4 className="font-bold text-[#631bb7] mb-2" data-id="element-2100">
                      Education Deficit
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-2101">
                      We teach families to be self-sufficient, not dependent. No
                      competitor has an education-first model.
                    </p>
                  </div>
                  <div className="bg-[#f0ebf8] p-5 rounded-xl border border-[#e0d8f0]" data-id="element-2102">
                    <h4 className="font-bold text-[#631bb7] mb-2" data-id="element-2103">
                      Multi-Generational Design
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-2104">
                      We serve the entire family unit with role-aware
                      experiences. No competitor addresses the stewardship
                      relationship.
                    </p>
                  </div>
                  <div className="bg-[#f0ebf8] p-5 rounded-xl border border-[#e0d8f0]" data-id="element-2105">
                    <h4 className="font-bold text-[#631bb7] mb-2" data-id="element-2106">
                      Trust Misalignment
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-2107">
                      Our fiduciary pledge is structurally impossible for any
                      competitor to replicate without destroying their own
                      business model. Although we may earn affiliate revenue,
                      all suggestions are based on independent evaluation of
                      what we believe will best serve your family's needs.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Founder Story */}
          <section id="founder-story" className="scroll-mt-24 space-y-8" data-id="element-2108">
            <div data-id="element-2109">
              <p className="text-xs font-bold text-[#631bb7] uppercase tracking-wider mb-2" data-id="element-2110">
                Section 6
              </p>
              <h2 className="text-3xl md:text-4xl font-bold text-[#111111]" data-id="element-2111">
                Born From The Brady Phillips Household
              </h2>
            </div>

            <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 shadow-sm space-y-8" data-id="element-2112">
              <div className="flex items-center gap-4 pb-6 border-b border-gray-100" data-id="element-2113">
                <div className="w-14 h-14 rounded-full bg-[#f0ebf8] flex items-center justify-center text-2xl shrink-0" data-id="element-2114">
                  👤
                </div>
                <div data-id="element-2115">
                  <h3 className="text-xl font-bold text-[#111111]" data-id="element-2116">
                    Jason Phillips
                  </h3>
                  <p className="text-sm text-[#631bb7] font-medium" data-id="element-2117">
                    Founder & CEO
                  </p>
                </div>
              </div>

              <div className="space-y-6 text-gray-600 leading-relaxed" data-id="element-2118">
                <p data-id="element-2119">
                  Caveo exists because I lived the problem I'm now solving. What
                  started as simple tech support for my parents' first iPhones
                  evolved into a full-scale management role. Over time, it was
                  just easier if I handled everything: internet plans, cell
                  service, subscriptions, and smart home devices. It wasn't that
                  my parents, Lois and Dan, lacked capability; it was that the
                  systems had become intentionally complex, the trade-offs
                  opaque, and the stakes quietly climbing. Calling a provider to
                  negotiate a plan you don't fully understand is frustrating for
                  anyone — for my parents, it was a burden they never asked for.
                  I stepped in to protect their independence, hoping to build
                  their digital literacy along the way. At the time, I didn't
                  think I was doing anything special. I was just looking after
                  the people who had looked after me for decades.
                </p>
                <p data-id="element-2120">
                  But I soon realized they weren't just vulnerable to scammers;
                  they were vulnerable to the entire tech ecosystem. Internet
                  Service Providers would offer "free" hardware, only to quietly
                  bill for it a year later. Local IT "pros" would recommend
                  unnecessary replacements, assuming my parents understood the
                  "fix." Whether malicious or merely indifferent, the result was
                  the same: people who aren't technical or aggressive
                  negotiators get the short end of the deal. Repeatedly.
                  Invisibly.
                </p>

                <div className="bg-[#fef3f2] border border-red-100 rounded-xl p-6" data-id="element-2121">
                  <p className="text-gray-700 leading-relaxed" data-id="element-2122">
                    In 2022, the reality of the situation hit me. My cousin
                    texted: someone was impersonating my dad on Facebook. As I
                    sat down to fix it, my mom mentioned — almost in passing —
                    that Dad had recently been scammed out of{' '}
                    <strong className="text-[#111111]" data-id="element-2123">$4,500</strong>. A caller
                    impersonating his bank's fraud department had socially
                    engineered him into draining his account. He had spent hours
                    on the phone and made multiple trips to the bank in a state
                    of high-stress crisis.
                  </p>
                </div>

                <p data-id="element-2124">
                  While the bank eventually covered the loss, the damage was
                  already done. What hit me hardest was not the money; it was
                  the silence. My parents hadn't told me because they didn't
                  want to be a "burden." Even in a crisis, they didn't want to
                  ask for help. I immediately felt responsible. This had
                  happened on my watch.
                </p>
                <p data-id="element-2125">
                  That guilt grew as I looked around. I realized my friends'
                  parents were in the same boat, but most adult children aren't
                  "overseeing" anything. Research from AARP and FOSI confirms
                  this: 94% of elderly relatives turn to family for tech help,
                  yet most of us are overwhelmed. I also noticed the theft of
                  time. Roughly a third of every visit with my parents was
                  consumed by troubleshooting. Every hour spent staring at a
                  router is an hour of quality time we can never get back.
                </p>
                <p data-id="element-2126">
                  The insight came slowly: My parents' generation was never
                  trained for this digital minefield. In my professional life, I
                  have mandatory cybersecurity training because companies
                  understand the risk. My parents were handed powerful,
                  interconnected tools and expected to navigate them with zero
                  onboarding. No education; just consequences.
                </p>

                <div className="bg-[#f0ebf8] border border-[#e0d8f0] rounded-xl p-6" data-id="element-2127">
                  <p className="text-[#111111] font-medium leading-relaxed" data-id="element-2128">
                    That is why I built Caveo. Caveo exists not just to stop
                    hackers, but to protect families from an ecosystem that
                    profits from their confusion. We aren't just a security
                    tool; we are the Family IT Department. We tell you when
                    you're being overcharged, recommend what actually works, and
                    never profit from pointing you in the wrong direction. Our
                    story began with Lois and Dan, and it continues with a team
                    dedicated to ensuring no family has to navigate the digital
                    world alone. This problem is systemic — but it is fixable.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Product Roadmap */}
          <section id="product-roadmap" className="scroll-mt-24 space-y-8" data-id="element-2129">
            <div data-id="element-2130">
              <p className="text-xs font-bold text-[#631bb7] uppercase tracking-wider mb-2" data-id="element-2131">
                Section 7
              </p>
              <h2 className="text-3xl md:text-4xl font-bold text-[#111111]" data-id="element-2132">
                Sequenced for Maximum Impact
              </h2>
            </div>

            <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 shadow-sm space-y-10" data-id="element-2133">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2134">
                {/* Phase 1 */}
                <div className="border-2 border-[#631bb7] rounded-xl overflow-hidden" data-id="element-2135">
                  <div className="bg-[#631bb7] text-white p-4" data-id="element-2136">
                    <p className="text-xs font-bold uppercase tracking-wider opacity-80" data-id="element-2137">
                      Phase 1
                    </p>
                    <h4 className="font-bold text-lg text-[#F8F8F8]" data-id="element-2138">
                      iOS App & Core Curriculum
                    </h4>
                    <p className="text-sm opacity-80 mt-1" data-id="element-2139">Months 0-6</p>
                  </div>
                  <ul className="p-5 space-y-3 text-sm text-gray-600" data-id="element-2140">
                    <li className="flex items-start gap-2" data-id="element-2141">
                      <span className="text-[#631bb7] mt-0.5" data-id="element-2142">•</span>iOS native
                      app launch
                    </li>
                    <li className="flex items-start gap-2" data-id="element-2143">
                      <span className="text-[#631bb7] mt-0.5" data-id="element-2144">•</span>37-module
                      curriculum (Levels 1-3)
                    </li>
                    <li className="flex items-start gap-2" data-id="element-2145">
                      <span className="text-[#631bb7] mt-0.5" data-id="element-2146">•</span>
                      1,000-point scoring system
                    </li>
                    <li className="flex items-start gap-2" data-id="element-2147">
                      <span className="text-[#631bb7] mt-0.5" data-id="element-2148">•</span>Family
                      dashboard (role-based)
                    </li>
                    <li className="flex items-start gap-2" data-id="element-2149">
                      <span className="text-[#631bb7] mt-0.5" data-id="element-2150">•</span>20 pilot
                      families → paid acquisition
                    </li>
                  </ul>
                </div>

                {/* Phase 2 */}
                <div className="border-2 border-gray-200 rounded-xl overflow-hidden" data-id="element-2151">
                  <div className="bg-[#1a0647] text-white p-4" data-id="element-2152">
                    <p className="text-xs font-bold uppercase tracking-wider opacity-80" data-id="element-2153">
                      Phase 2
                    </p>
                    <h4 className="font-bold text-lg text-[#F8F8F8]" data-id="element-2154">
                      Android & Remote Assist
                    </h4>
                    <p className="text-sm opacity-80 mt-1" data-id="element-2155">Months 6-12</p>
                  </div>
                  <ul className="p-5 space-y-3 text-sm text-gray-600" data-id="element-2156">
                    <li className="flex items-start gap-2" data-id="element-2157">
                      <span className="text-[#631bb7] mt-0.5" data-id="element-2158">•</span>Android
                      native app
                    </li>
                    <li className="flex items-start gap-2" data-id="element-2159">
                      <span className="text-[#631bb7] mt-0.5" data-id="element-2160">•</span>Remote
                      Assist launch ($9.99/mo)
                    </li>
                    <li className="flex items-start gap-2" data-id="element-2161">
                      <span className="text-[#631bb7] mt-0.5" data-id="element-2162">•</span>Managed
                      Services ($199/hr)
                    </li>
                    <li className="flex items-start gap-2" data-id="element-2163">
                      <span className="text-[#631bb7] mt-0.5" data-id="element-2164">•</span>CANZUS
                      market expansion (Canada, Australia, NZ)
                    </li>
                    <li className="flex items-start gap-2" data-id="element-2165">
                      <span className="text-[#631bb7] mt-0.5" data-id="element-2166">•</span>10,000
                      paying families target
                    </li>
                  </ul>
                </div>

                {/* Phase 3 */}
                <div className="border-2 border-gray-200 rounded-xl overflow-hidden" data-id="element-2167">
                  <div className="bg-gray-800 text-white p-4" data-id="element-2168">
                    <p className="text-xs font-bold uppercase tracking-wider opacity-80" data-id="element-2169">
                      Phase 3
                    </p>
                    <h4 className="font-bold text-lg text-[#F8F8F8]" data-id="element-2170">
                      Family SSO & IAM Infrastructure
                    </h4>
                    <p className="text-sm opacity-80 mt-1" data-id="element-2171">Year 2+</p>
                  </div>
                  <ul className="p-5 space-y-3 text-sm text-gray-600" data-id="element-2172">
                    <li className="flex items-start gap-2" data-id="element-2173">
                      <span className="text-[#631bb7] mt-0.5" data-id="element-2174">•</span>Family
                      Single Sign-On (SSO)
                    </li>
                    <li className="flex items-start gap-2" data-id="element-2175">
                      <span className="text-[#631bb7] mt-0.5" data-id="element-2176">•</span>Identity
                      Access Management (IAM)
                    </li>
                    <li className="flex items-start gap-2" data-id="element-2177">
                      <span className="text-[#631bb7] mt-0.5" data-id="element-2178">•</span>Digital
                      estate planning tools
                    </li>
                    <li className="flex items-start gap-2" data-id="element-2179">
                      <span className="text-[#631bb7] mt-0.5" data-id="element-2180">•</span>Enterprise
                      benefit programs
                    </li>
                    <li className="flex items-start gap-2" data-id="element-2181">
                      <span className="text-[#631bb7] mt-0.5" data-id="element-2182">•</span>Series A
                      readiness
                    </li>
                  </ul>
                </div>
              </div>

              <div className="bg-[#f0ebf8] border border-[#e0d8f0] rounded-xl p-6" data-id="element-2183">
                <h3 className="text-lg font-bold text-[#631bb7] mb-3" data-id="element-2184">
                  The Strategic Moat: Family SSO & IAM
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-2185">
                  Phase 3 is where Caveo transitions from an education platform
                  to infrastructure. Family Single Sign-On and Identity Access
                  Management create the switching costs that transform Caveo
                  from a subscription into a dependency. Once a family's digital
                  identity is managed through Caveo, the cost of leaving becomes
                  prohibitive. This is the enterprise IT playbook applied to
                  households: start with education, earn trust, become
                  infrastructure.
                </p>
              </div>
            </div>
          </section>

          {/* Business Model */}
          <section id="business-model" className="scroll-mt-24 space-y-8" data-id="element-2186">
            <div data-id="element-2187">
              <p className="text-xs font-bold text-[#631bb7] uppercase tracking-wider mb-2" data-id="element-2188">
                Section 8
              </p>
              <h2 className="text-3xl md:text-4xl font-bold text-[#111111]" data-id="element-2189">
                How Caveo Makes Money
              </h2>
            </div>

            <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 shadow-sm space-y-10" data-id="element-2190">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2191">
                <div className="border-2 border-gray-200 rounded-xl p-6 text-center flex flex-col items-center" data-id="element-2192">
                  <h4 className="font-bold text-lg text-[#111111] mb-1" data-id="element-2193">
                    Individual
                  </h4>
                  <span className="text-4xl font-bold text-[#631bb7] mb-3" data-id="element-2194">
                    $7.99<span className="text-lg text-gray-400" data-id="element-2195">/mo</span>
                  </span>
                  <p className="text-sm text-gray-600" data-id="element-2196">
                    Single user. Core curriculum, scoring, and AI guide.
                  </p>
                </div>
                <div className="border-2 border-[#631bb7] rounded-xl p-6 text-center flex flex-col items-center relative" data-id="element-2197">
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#631bb7] text-white text-[10px] font-bold uppercase tracking-wider px-3 py-1 rounded-full" data-id="element-2198">
                    Most Popular
                  </div>
                  <h4 className="font-bold text-lg text-[#111111] mb-1" data-id="element-2199">
                    Family
                  </h4>
                  <span className="text-4xl font-bold text-[#631bb7] mb-3" data-id="element-2200">
                    $19.99<span className="text-lg text-gray-400" data-id="element-2201">/mo</span>
                  </span>
                  <p className="text-sm text-gray-600" data-id="element-2202">
                    Up to 6 members. Role-based dashboards, family coordination,
                    and shared governance.
                  </p>
                </div>
                <div className="border-2 border-gray-200 rounded-xl p-6 text-center flex flex-col items-center" data-id="element-2203">
                  <h4 className="font-bold text-lg text-[#111111] mb-1" data-id="element-2204">
                    Remote Assist
                  </h4>
                  <span className="text-4xl font-bold text-[#631bb7] mb-3" data-id="element-2205">
                    $9.99<span className="text-lg text-gray-400" data-id="element-2206">/mo</span>
                  </span>
                  <p className="text-sm text-gray-600" data-id="element-2207">
                    Add-on. Live human support for implementation and
                    troubleshooting.
                  </p>
                </div>
              </div>

              <div className="space-y-4" data-id="element-2208">
                <h3 className="text-xl font-bold text-[#631bb7]" data-id="element-2209">
                  Managed Services
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-2210">
                  For families that need hands-on implementation support beyond
                  Remote Assist, Caveo offers Managed Services at{' '}
                  <strong className="text-[#111111]" data-id="element-2211">$199/hour</strong>. This is
                  not the core business model. It is a premium service that
                  serves the most complex family situations while generating
                  high-margin revenue and deepening the relationship with our
                  most valuable customers.
                </p>
              </div>

              <div className="bg-[#f0ebf8] border border-[#e0d8f0] rounded-xl p-6" data-id="element-2212">
                <h3 className="text-lg font-bold text-[#631bb7] mb-3" data-id="element-2213">
                  The Privacy-First Revenue Model
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-2214">
                  Caveo's revenue comes entirely from subscriptions. We earn
                  zero affiliate revenue, sell zero user data, and accept zero
                  advertising. This is not a marketing position. It is a
                  structural commitment that makes our recommendations
                  trustworthy. When we tell a family they don't need a VPN, they
                  can believe us. When we recommend a password manager, they
                  know we're not being paid to say so.
                </p>
              </div>
            </div>
          </section>

          {/* Go-to-Market */}
          <section id="go-to-market" className="scroll-mt-24 space-y-8" data-id="element-2215">
            <div data-id="element-2216">
              <p className="text-xs font-bold text-[#631bb7] uppercase tracking-wider mb-2" data-id="element-2217">
                Section 9
              </p>
              <h2 className="text-3xl md:text-4xl font-bold text-[#111111]" data-id="element-2218">
                From Friends & Family to Paying Households
              </h2>
            </div>

            <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 shadow-sm space-y-10" data-id="element-2219">
              <div className="space-y-4" data-id="element-2220">
                <h3 className="text-xl font-bold text-[#631bb7]" data-id="element-2221">
                  Organic & Referral (Now)
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-2222">
                  We are currently in stealth mode rebuilding the MVP to include
                  the proper consent mechanisms and data + security safeguards
                  before rolling out a controlled alpha across the (3) customer
                  personas. The go-to-market begins with friends and family,
                  then expands to targeted content marketing and community-based
                  acquisition before any paid advertising. This sequencing
                  ensures we have strong product-market fit evidence before
                  spending on acquisition.
                </p>
              </div>

              <div className="space-y-4" data-id="element-2223">
                <h3 className="text-xl font-bold text-[#631bb7]" data-id="element-2224">
                  Content Strategy: Building the Category
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-2225">
                  Caveo's content pillars are Family Security, Change Management
                  for Families, Scam Prevention as a Team Sport, Tool
                  Consolidation, and Contrarian Thinking. Distribution leverages
                  AthenaHQ for Generate Engine Optimization (GEO) which
                  optimizes content for AI Search from the beginning, guest
                  posts, podcast appearances, LinkedIn thought leadership, and
                  Reddit community participation. The goal is to establish Jason
                  and Caveo as the trusted authorities on family digital
                  security with enterprise-grade methodology.
                </p>
              </div>

              <div className="space-y-4" data-id="element-2226">
                <h3 className="text-xl font-bold text-[#631bb7]" data-id="element-2227">
                  Partnership Channels
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2228">
                  <div className="bg-gray-50 border border-gray-100 rounded-xl p-5" data-id="element-2229">
                    <div className="text-2xl mb-2" data-id="element-2230">🏢</div>
                    <h4 className="font-bold text-[#111111] mb-2" data-id="element-2231">
                      Enterprises
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-2232">
                      Employee benefit programs for remote workers. 'Secure your
                      family's home network' as part of work-from-home security
                      initiatives.
                    </p>
                  </div>
                  <div className="bg-gray-50 border border-gray-100 rounded-xl p-5" data-id="element-2233">
                    <div className="text-2xl mb-2" data-id="element-2234">🏦</div>
                    <h4 className="font-bold text-[#111111] mb-2" data-id="element-2235">
                      Financial Institutions
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-2236">
                      Credit unions and community banks offer Caveo as a member
                      benefit, reducing their exposure to member fraud losses.
                    </p>
                  </div>
                  <div className="bg-gray-50 border border-gray-100 rounded-xl p-5" data-id="element-2237">
                    <div className="text-2xl mb-2" data-id="element-2238">👴</div>
                    <h4 className="font-bold text-[#111111] mb-2" data-id="element-2239">
                      Senior Living Communities
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-2240">
                      Technology confidence and safety programs for residents,
                      reducing facility liability and improving family peace of
                      mind.
                    </p>
                  </div>
                  <div className="bg-gray-50 border border-gray-100 rounded-xl p-5" data-id="element-2241">
                    <div className="text-2xl mb-2" data-id="element-2242">💸</div>
                    <h4 className="font-bold text-[#111111] mb-2" data-id="element-2243">
                      Paid Acquisition (Post-PMF)
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-2244">
                      Meta/Google ads targeting Millennials with aging parents.
                      Retargeting visitors to Crisis Guide content.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Fundraising */}
          <section id="fundraising" className="scroll-mt-24 space-y-8" data-id="element-2245">
            <div data-id="element-2246">
              <p className="text-xs font-bold text-[#631bb7] uppercase tracking-wider mb-2" data-id="element-2247">
                Section 10
              </p>
              <h2 className="text-3xl md:text-4xl font-bold text-[#111111]" data-id="element-2248">
                The Inflection Point Round
              </h2>
            </div>

            <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 shadow-sm space-y-10" data-id="element-2249">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2250">
                <div className="bg-[#1a0647] text-white rounded-xl p-6 text-center" data-id="element-2251">
                  <p className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-2" data-id="element-2252">
                    Round
                  </p>
                  <span className="text-4xl font-bold" data-id="element-2253">$275,000</span>
                  <p className="text-sm text-gray-300 mt-1" data-id="element-2254">SAFE</p>
                </div>
                <div className="bg-[#1a0647] text-white rounded-xl p-6 text-center" data-id="element-2255">
                  <p className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-2" data-id="element-2256">
                    Valuation Cap
                  </p>
                  <span className="text-4xl font-bold" data-id="element-2257">$8M</span>
                  <p className="text-sm text-gray-300 mt-1" data-id="element-2258">Post-Money</p>
                </div>
              </div>

              <p className="text-gray-600 leading-relaxed" data-id="element-2259">
                We have reached an inflection point. The $275,000 SAFE round is
                about capitalizing on four converging forces to accelerate our
                go-to-market strategy. The technology is ready, the demand is
                proven, the competitive vacuum exists right now, and the
                audience is primed to act. This round is how we step into it.
              </p>

              <div className="space-y-4" data-id="element-2260">
                <h3 className="text-xl font-bold text-[#631bb7]" data-id="element-2261">
                  The Four Converging Forces
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2262">
                  <div className="bg-[#f0ebf8] border border-[#e0d8f0] rounded-xl p-5" data-id="element-2263">
                    <h4 className="font-bold text-[#631bb7] mb-2" data-id="element-2264">
                      Technology Ready
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-2265">
                      The AI infrastructure required to deliver personalized,
                      plain-English guidance at scale is now economically
                      viable. We have built the curriculum, the scoring system,
                      and the role-based architecture.
                    </p>
                  </div>
                  <div className="bg-[#f0ebf8] border border-[#e0d8f0] rounded-xl p-5" data-id="element-2266">
                    <h4 className="font-bold text-[#631bb7] mb-2" data-id="element-2267">
                      Demand Proven
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-2268">
                      Cybercrime losses hit $16.6B in 2024. 73M Baby Boomers are
                      aging into their most vulnerable digital years. The demand
                      is not theoretical.
                    </p>
                  </div>
                  <div className="bg-[#f0ebf8] border border-[#e0d8f0] rounded-xl p-5" data-id="element-2269">
                    <h4 className="font-bold text-[#631bb7] mb-2" data-id="element-2270">
                      Competitive Vacuum
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-2271">
                      No existing competitor addresses the multi-generational
                      family unit with an education-first, fiduciary model. The
                      white space is real and it is right now.
                    </p>
                  </div>
                  <div className="bg-[#f0ebf8] border border-[#e0d8f0] rounded-xl p-5" data-id="element-2272">
                    <h4 className="font-bold text-[#631bb7] mb-2" data-id="element-2273">
                      Audience Primed
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-2274">
                      COVID permanently accelerated digital adoption across all
                      age groups. Families are more digitally active and more
                      digitally anxious than at any point in history.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Curriculum */}
          <section id="curriculum" className="scroll-mt-24 space-y-8" data-id="element-2275">
            <div data-id="element-2276">
              <p className="text-xs font-bold text-[#631bb7] uppercase tracking-wider mb-2" data-id="element-2277">
                Section 11 — Appendix
              </p>
              <h2 className="text-3xl md:text-4xl font-bold text-[#111111]" data-id="element-2278">
                37 Modules. 1,000 Points. Legitimate Security.
              </h2>
            </div>

            <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 shadow-sm space-y-10" data-id="element-2279">
              <p className="text-gray-600 leading-relaxed" data-id="element-2280">
                The Caveo curriculum was developed through analysis of the NIST
                cybersecurity framework adapted for consumers, review of 15+
                enterprise security training programs, interviews with 50+
                families about their actual security pain points, prioritization
                based on threat frequency and impact data from FBI IC3 reports,
                and pilot testing with 25 families to validate sequencing and
                difficulty progression.
              </p>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2281">
                <div className="bg-gray-50 border border-gray-100 rounded-xl p-6 text-center" data-id="element-2282">
                  <span className="text-4xl font-bold text-[#631bb7] mb-2 block" data-id="element-2283">
                    37
                  </span>
                  <span className="font-bold text-[#111111] text-sm block mb-1" data-id="element-2284">
                    Total Learning Experiences
                  </span>
                  <span className="text-xs text-gray-500" data-id="element-2285">
                    1 intro + 28 core + 8 specialized guides
                  </span>
                </div>
                <div className="bg-gray-50 border border-gray-100 rounded-xl p-6 text-center" data-id="element-2286">
                  <span className="text-4xl font-bold text-[#631bb7] mb-2 block" data-id="element-2287">
                    6-8 hrs
                  </span>
                  <span className="font-bold text-[#111111] text-sm block mb-1" data-id="element-2288">
                    Levels 1-2 Completion
                  </span>
                  <span className="text-xs text-gray-500" data-id="element-2289">
                    Legitimate security achieved
                  </span>
                </div>
                <div className="bg-gray-50 border border-gray-100 rounded-xl p-6 text-center" data-id="element-2290">
                  <span className="text-4xl font-bold text-[#631bb7] mb-2 block" data-id="element-2291">
                    1,000 pts
                  </span>
                  <span className="font-bold text-[#111111] text-sm block mb-1" data-id="element-2292">
                    Perfect Score
                  </span>
                  <span className="text-xs text-gray-500" data-id="element-2293">
                    Comprehensive household protection
                  </span>
                </div>
              </div>

              {/* Level 1 */}
              <div className="space-y-4" data-id="element-2294">
                <div className="flex items-center justify-between" data-id="element-2295">
                  <h3 className="text-xl font-bold text-[#631bb7]" data-id="element-2296">
                    Level 1: Essential Digital Safety
                  </h3>
                  <span className="text-sm font-medium text-gray-500 bg-gray-100 px-3 py-1 rounded-full" data-id="element-2297">
                    450 Points · 9 Modules
                  </span>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-2298">
                  {['Creating Bulletproof Passwords (12 min)', 'Two-Factor Authentication Basics (10 min)', 'Securing Your Home Wi-Fi Network (15 min)', 'Securing Your Phone (10 min)', 'Securing Your Computer (10 min)', 'Securing Your Most Important Accounts (15 min)', 'Recognizing Scams & Phishing (15 min)', 'Software Updates & Why They Matter (8 min)', 'Backing Up Your Devices (12 min)'].map((module, idx) => <div key={idx} className="flex items-center gap-3 bg-gray-50 border border-gray-100 rounded-lg px-4 py-3" data-id="element-2299">
                      <div className="w-6 h-6 rounded-full bg-[#f0ebf8] text-[#631bb7] text-xs font-bold flex items-center justify-center shrink-0" data-id="element-2300">
                        {idx + 1}
                      </div>
                      <span className="text-sm text-gray-600" data-id="element-2301">{module}</span>
                    </div>)}
                </div>
              </div>

              {/* Level 2 */}
              <div className="space-y-4" data-id="element-2302">
                <div className="flex items-center justify-between" data-id="element-2303">
                  <h3 className="text-xl font-bold text-[#631bb7]" data-id="element-2304">
                    Level 2: Intermediate Protection
                  </h3>
                  <span className="text-sm font-medium text-gray-500 bg-gray-100 px-3 py-1 rounded-full" data-id="element-2305">
                    550 Points · 11 Modules
                  </span>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-2306">
                  {['Browser Security & Privacy', 'Social Media Privacy', 'Mobile Device Security', 'Smart Home Security', 'Financial Account Security', 'Identity Theft Protection', 'Privacy Best Practices', 'Cloud Storage Security', 'Email Security', 'Safe Online Shopping', 'Family Digital Coordination'].map((module, idx) => <div key={idx} className="flex items-center gap-3 bg-gray-50 border border-gray-100 rounded-lg px-4 py-3" data-id="element-2307">
                      <div className="w-6 h-6 rounded-full bg-[#f0ebf8] text-[#631bb7] text-xs font-bold flex items-center justify-center shrink-0" data-id="element-2308">
                        {idx + 10}
                      </div>
                      <span className="text-sm text-gray-600" data-id="element-2309">{module}</span>
                    </div>)}
                </div>
              </div>

              {/* Level 3 */}
              <div className="flex items-center justify-between flex-wrap gap-2" data-id="element-2310">
                <h3 className="text-xl font-bold text-[#631bb7]" data-id="element-2311">
                  Level 3: Advanced Optimization
                </h3>
                <span className="text-sm font-medium text-gray-500 bg-gray-100 px-3 py-1 rounded-full" data-id="element-2312">
                  8 Modules
                </span>
              </div>
              <p className="text-gray-600 leading-relaxed" data-id="element-2313">
                Advanced capabilities for users who have completed Levels 1 and
                2 and want to maximize their digital security posture. Covers
                specialized topics from VPN selection to cryptocurrency
                security. 3-4 additional hours of learning time.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-2314">
                {[{
                name: 'VPN Usage & Selection',
                time: '10 min',
                outcome: 'Understands specific use cases for VPNs and can choose a trustworthy provider.'
              }, {
                name: 'Encrypted Communications',
                time: '12 min',
                outcome: 'Understands the basics of email and file encryption.'
              }, {
                name: 'Advanced Privacy Tools',
                time: '10 min',
                outcome: 'Can use privacy-focused browsers, search engines, and ad blockers.'
              }, {
                name: 'Digital Estate Planning',
                time: '15 min',
                outcome: 'Can create a digital asset inventory and set up account executors.'
              }, {
                name: 'Security for Remote Work',
                time: '10 min',
                outcome: 'Can secure their home office network and understand the division between company and personal devices.'
              }, {
                name: 'Cryptocurrency Security',
                time: '12 min',
                outcome: 'Understands the difference between hot and cold storage and can identify common crypto scams.'
              }, {
                name: 'Advanced Threat Detection',
                time: '10 min',
                outcome: 'Can recognize the signs of advanced persistent threats and knows where to find reliable threat information.'
              }, {
                name: 'Privacy-Focused Alternatives',
                time: '10 min',
                outcome: 'Is aware of privacy-respecting alternatives for email, cloud storage, and other services.'
              }].map((module, idx) => <div key={idx} className="flex items-start gap-3 bg-gray-50 border border-gray-100 rounded-lg px-4 py-3" data-id="element-2315">
                    <div className="w-6 h-6 rounded-full bg-[#f0ebf8] text-[#631bb7] text-xs font-bold flex items-center justify-center shrink-0 mt-0.5" data-id="element-2316">
                      {idx + 21}
                    </div>
                    <div className="min-w-0" data-id="element-2317">
                      <span className="text-sm text-gray-800 font-medium" data-id="element-2318">
                        {module.name}{' '}
                        <span className="text-gray-400 font-normal" data-id="element-2319">
                          ({module.time})
                        </span>
                      </span>
                      <p className="text-xs text-gray-500 mt-1 leading-relaxed" data-id="element-2320">
                        {module.outcome}
                      </p>
                    </div>
                  </div>)}
              </div>
              {/* Specialized Guides */}
              <div className="space-y-4" data-id="element-2321">
                <div className="flex items-center justify-between flex-wrap gap-2" data-id="element-2322">
                  <h3 className="text-xl font-bold text-[#631bb7]" data-id="element-2323">
                    Specialized Guides
                  </h3>
                  <span className="text-sm font-medium text-gray-500 bg-gray-100 px-3 py-1 rounded-full" data-id="element-2324">
                    8 Guides
                  </span>
                </div>
                <p className="text-gray-600 leading-relaxed" data-id="element-2325">
                  Standalone guides addressing specific family situations and
                  emerging technology challenges. Each guide is self-contained
                  and can be completed independently of the core curriculum.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-2326">
                  {['Reducing Spam & Junk Mail', 'AI Primer & Using AI Safely', 'Masking Identity for Online Dating', 'Replacing ISP Modem/Router', 'Setting Up Parental Controls', 'Secure File Sharing for Families', 'Digital Legacy Planning', 'Smart Home Ecosystem Selection'].map((guide, idx) => <div key={idx} className="flex items-center gap-3 bg-[#f0ebf8] border border-[#e0d8f0] rounded-lg px-4 py-3" data-id="element-2327">
                      <div className="w-6 h-6 rounded-full bg-white text-[#631bb7] text-xs font-bold flex items-center justify-center shrink-0" data-id="element-2328">
                        📖
                      </div>
                      <span className="text-sm text-gray-700 font-medium" data-id="element-2329">
                        {guide}
                      </span>
                    </div>)}
                </div>
              </div>
            </div>
          </section>

          {/* Glossary */}
          <section id="glossary" className="scroll-mt-24 space-y-8" data-id="element-2330">
            <div data-id="element-2331">
              <p className="text-xs font-bold text-[#631bb7] uppercase tracking-wider mb-2" data-id="element-2332">
                Section 12
              </p>
              <h2 className="text-3xl md:text-4xl font-bold text-[#111111]" data-id="element-2333">
                Key Terms
              </h2>
            </div>

            <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 shadow-sm space-y-2" data-id="element-2334">
              <p className="text-gray-600 leading-relaxed mb-6" data-id="element-2335">
                Caveo uses plain English throughout the platform. These
                definitions reflect how we explain these concepts to families,
                not how the security industry defines them for engineers.
              </p>

              {[{
              term: 'ADKAR',
              def: 'A change management framework (Awareness, Desire, Knowledge, Ability, Reinforcement) used by Fortune 500 companies to drive organizational transformation. Caveo applies this framework to household digital security.'
            }, {
              term: 'Digital Literacy Gap',
              def: 'The space between the tools that exist to protect people online and the knowledge required to use them effectively. Caveo exists to close this gap.'
            }, {
              term: 'Family IT Platform',
              def: "Caveo's category definition. A unified platform that provides the infrastructure, security, productivity, and governance functions of a corporate IT department, adapted for the modern household."
            }, {
              term: 'Family Tech Steward',
              def: "The tech-savvy family member (typically a Millennial adult child) who manages digital security for their entire family. Caveo's primary ICP."
            }, {
              term: 'Fiduciary Pledge',
              def: "Caveo's commitment to earn zero affiliate revenue, recommend against unnecessary spending, and succeed only when our families succeed."
            }, {
              term: 'Governance Charter',
              def: 'A shared family agreement about digital roles, permissions, and expectations. The household equivalent of a corporate IT policy.'
            }, {
              term: 'SAFE',
              def: 'Simple Agreement for Future Equity. The instrument Caveo is using for its current $275K fundraising round.'
            }, {
              term: 'Stewardship',
              def: "Caveo's core philosophy. We help families achieve self-sufficiency with human support available when truly needed. The opposite of surveillance or dependency."
            }, {
              term: '3-2-1 Backup Rule',
              def: 'Three copies of your data, on two different media types, with one copy offsite. The industry-standard backup strategy that Caveo teaches in Level 1.'
            }].map((item, idx) => <div key={idx} className="py-4 border-b border-gray-100 last:border-b-0" data-id="element-2336">
                  <h4 className="font-bold text-[#111111] mb-1" data-id="element-2337">{item.term}</h4>
                  <p className="text-sm text-gray-600 leading-relaxed" data-id="element-2338">
                    {item.def}
                  </p>
                </div>)}
            </div>
          </section>

          {/* Bottom spacing */}
          <div className="h-12" data-id="element-2339"></div>
        </main>
      </div>

      <footer className="bg-white border-t border-gray-200 py-6 md:py-8 mt-auto" data-id="element-2340">
        <div className="max-w-7xl mx-auto px-4 md:px-6 text-center text-xs md:text-sm text-gray-500" data-id="element-2341">
          <p data-id="element-2342">&copy; 2026 AppEmbrace, Inc. DBA Caveo. All rights reserved.</p>
          <p className="mt-1 md:mt-2 text-xs text-gray-400" data-id="element-2343">
            This page contains confidential information intended only for
            authorized investors. Do not share or distribute without permission.
          </p>
        </div>
      </footer>
    </div>;
}